var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakephoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.8,
    height: 12.8,
    viewBox: "0 0 14.8 12.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.1 -62.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d71b4",
    strokeWidth: "0.8px",
    d: "M238.082,203.367H236.4a.629.629,0,0,1-.553-.427l-.434-1.4a.629.629,0,0,0-.553-.427H230.1a.628.628,0,0,0-.553.427l-.434,1.4a.629.629,0,0,1-.553.427h-1.68a1.457,1.457,0,0,0-1.4,1.5v6.75a1.457,1.457,0,0,0,1.4,1.5h11.2a1.457,1.457,0,0,0,1.4-1.5v-6.75A1.457,1.457,0,0,0,238.082,203.367Z",
    transform: "translate(-202.982 -138.617)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3d71b4",
    strokeWidth: "0.8px",
    transform: "translate(26.8 66)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 3,
    cy: 3,
    r: 2.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakephoto);
export default __webpack_public_path__ + "static/media/takephoto.87aa332d.svg";
export { ForwardRef as ReactComponent };